import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IAdminActionItem {
  workerID: string;
  workerFirstName: string;
  workerLastName: string;
  workerType: string;
  category:
    | "form_i9"
    | "kyc"
    | "onboarding"
    | "additional_requirements"
    | "expired_documents";
  action: string;
  label: string;
  priority: "p0" | "p1" | "p2";
}

export const getAdminActionItems = (axios: IAxiosInstance) => {
  return async (companyID: string) => {
    const response = await axios.noRetry.get<IApiResponse<IAdminActionItem[]>>(
      "/api/admin-action-items",
      { params: { companyID } }
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
